module.exports = __webpack_public_path__ + "img/证书.396ae7e5.png";